var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.column.sortable && _vm.column.show)?_c('th',{ref:_vm.column.column,on:{"click":function($event){return _vm.sortByColumn(_vm.column.column)}}},[_vm._v(" "+_vm._s(_vm.column.title)+" "),_c('span',{staticClass:"sortIcon"})]):(_vm.column.show)?_c('th',[_vm._v(" "+_vm._s(_vm.column.title))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }